import { initSwiper } from '@resources/js/components/initSwiper.js'
import inViewport from '@resources/js/helpers/inViewport'
import hasHover from '@resources/js/helpers/hasHover'
import debounce from '@resources/js/helpers/debounce'

const DRAG_CLASS = 'dragging'
const moreOffersElement = document.querySelector('.js-more-stays')

inViewport(moreOffersElement, () => {
	// ініт головного слайдеру
	const mainSliderElement = moreOffersElement.querySelector(
		'.js-more-stays-slider'
	)

	// helpers
	const addClassToSlider = () => {
		const hasClass = mainSliderElement.classList.contains(DRAG_CLASS)
		if (!hasClass) {
			mainSliderElement.classList.add(DRAG_CLASS)
		}
	}
	const removeClassFromSlider = () =>
		mainSliderElement.classList.remove(DRAG_CLASS)

	const mainSliderConfig = {
		slidesPerView: 1.1,
		loop: false,
		spaceBetween: 16,
		mousewheel: {
			enabled: true,
			forceToAxis: true,
		},
		navigation: {
			nextEl: moreOffersElement.querySelector('.js-main-slider-next'),
			prevEl: moreOffersElement.querySelector('.js-main-slider-prev'),
		},
		breakpoints: {
			550: {
				slidesPerView: 1.7,
			},
			768: {
				slidesPerView: 2.2,
			},
			1100: {
				slidesPerView: 2.56,
				spaceBetween: 32,
			},
		},
	}

	initSwiper(mainSliderElement, mainSliderConfig)

	if (hasHover()) {
		const debounceRemoveClass = debounce(removeClassFromSlider, 300)

		mainSliderElement.addEventListener('swiperslidermove', addClassToSlider)
		mainSliderElement.addEventListener('swipertouchend', removeClassFromSlider)
		mainSliderElement.addEventListener('swiperscroll', () => {
			addClassToSlider()
			debounceRemoveClass()
		})
	}

	// ініт слайдерів карток
	const offerCardElements = moreOffersElement.querySelectorAll('.js-offer-card')

	offerCardElements.forEach(cardEl => {
		const offerSliderElement = cardEl.querySelector('.js-item-slider')

		if (!offerSliderElement) return

		const offerSliderConfig = {
			loop: false,
			allowTouchMove: false,
			navigation: {
				nextEl: cardEl.querySelector('.js-item-slider-next'),
				prevEl: cardEl.querySelector('.js-item-slider-prev'),
			},
			pagination: {
				el: cardEl.querySelector('.swiper-pagination'),
				type: 'bullets',
				dynamicBullets: true,
				dynamicMainBullets: 1,
			},
		}

		initSwiper(offerSliderElement, offerSliderConfig)
	})
})
